// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_a8c312b3"};